import { render, staticRenderFns } from "./SubAssunto.vue?vue&type=template&id=50099148&"
import script from "./SubAssunto.vue?vue&type=script&lang=js&"
export * from "./SubAssunto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SubAssunto.vue"
export default component.exports